import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { UploadsModel } from '../models/upload/uploads.model';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthGaurdService } from './auth-gaurd.service';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { UpdateManualDataComponent } from '../uploads/update-manual-data/update-manual-data.component';
import { UpdateManualDataModel } from '../models/upload/update_manual_data.model';
import { Kpimaster } from '../models/commission/kpimaster.model';

@Injectable({
    providedIn: 'root'
})

export class UpdateManualDataService {
    private host = environment.apiUrl + "uploads/manualupdates";

    public updateManualDataModel = new UpdateManualDataModel();
    //public updateManualDataModel: UpdateManualDataModel[] = [];
    public editAdjustmentsModel = new UpdateManualDataModel();
    public editGoalsModel = new UpdateManualDataModel();
    public myTemplateSet = new Set<string>();
    public loggedinUser: string = '';


    opts = [];
    optsEmpEmp = [];

    constructor(private http: HttpClient,
        private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
    }

    public getAdjustmentResults(updateManualDataModel: UpdateManualDataModel): Observable<UpdateManualDataModel[]> {
        return this.http.post<UpdateManualDataModel[]>(`${this.host}/getadjustmentresults`, updateManualDataModel);
    }

    public getGoalResults(updateManualDataModel: UpdateManualDataModel): Observable<UpdateManualDataModel[]> {
        return this.http.post<UpdateManualDataModel[]>(`${this.host}/getgoalresults`, updateManualDataModel);
    }

    public saveAdjustment(updateManualDataModel: UpdateManualDataModel): Observable<UpdateManualDataModel> {
        return this.http.post<UpdateManualDataModel>(`${this.host}/saveadjustment`, updateManualDataModel);
    }

    public saveGoal(updateManualDataModel: UpdateManualDataModel): Observable<UpdateManualDataModel> {
        return this.http.post<UpdateManualDataModel>(`${this.host}/savegoal`, updateManualDataModel);
    }

    public deleteAdjustment(id: number): Observable<CustomHttpRespone> {
        return this.http.delete<CustomHttpRespone>(`${this.host}/deleteadjustment/` + id);
    }

    public deleteGoal(id: number): Observable<CustomHttpRespone> {
        return this.http.delete<CustomHttpRespone>(`${this.host}/deletegoal/` + id);
    }

    public updateAdjustmentByID(updateManualDataModel: UpdateManualDataModel): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.host}/updateadjustment`, updateManualDataModel);
    }

    public updateGoalByID(updateManualDataModel: UpdateManualDataModel): Observable<CustomHttpRespone> {
        return this.http.put<CustomHttpRespone>(`${this.host}/updategoal`, updateManualDataModel);
    }

    public getAdjustmentsById(id: number): Observable<UpdateManualDataModel> {
        return this.http.get<UpdateManualDataModel>(`${this.host}/getadjustmentsbyid` + '/' + id);
    }

    public getGoalsById(id: number): Observable<UpdateManualDataModel> {
        return this.http.get<UpdateManualDataModel>(`${this.host}/getgoalsbyid` + '/' + id);
    }

    public searchAdjustmentResults(updateManualDataModel: UpdateManualDataModel): Observable<UpdateManualDataModel[]> {
        return this.http.post<UpdateManualDataModel[]>(`${this.host}/getadjustmentuploadresults`, updateManualDataModel);
    }

    public searchGoalsResults(updateManualDataModel: UpdateManualDataModel): Observable<UpdateManualDataModel[]> {
        return this.http.post<UpdateManualDataModel[]>(`${this.host}/getgoaluploadresults`, updateManualDataModel);
    }

    public getKpis(type:string): Observable<UpdateManualDataModel[]> {
        return this.http.get<UpdateManualDataModel[]>(`${this.host}/getkpis` + '/' + type);
    }

    public getCalRunIds(): Observable<UpdateManualDataModel[]> {
        return this.http.get<UpdateManualDataModel[]>(`${this.host}/getcalrunids`);
    }

    public getCommPlans(): Observable<UpdateManualDataModel[]> {
        return this.http.get<UpdateManualDataModel[]>(`${this.host}/getcommplans`);
    }


}


